// TODO: @lisilinhart we can probably remove this function in the future
// it's only used in a single place in `arrayUtils` when the "old way" is used

// TODO: @emanuelgsouza we need to add tests and refactor this code to
// understand how it should work to be used in the arrayUtils.find method

import type { BlockContent } from '@/types/content'
import decycle from './decycle'

export default function deepSearch(
  json: BlockContent,
  key: string,
  value: string | number,
): unknown {
  const res: BlockContent[] = []

  function match(obj: BlockContent, k: string): boolean {
    return key === k && obj[k] === value
  }

  function innerSearch(o: BlockContent, v: string | number): void {
    const search = function (
      obj: BlockContent,
      pattern: string | number,
      prefix = '',
    ): (a: string) => void {
      prefix = prefix || ''
      return function (a: string): void {
        if (typeof obj[a] === 'object' && obj[a] !== null) {
          Object.keys(obj[a]).forEach(
            search(
              // @ts-expect-error ensure obj[a] is a BlockContent
              obj[a],
              pattern,
              /\d+/.test(a)
                ? prefix + '[' + a + ']'
                : (prefix !== '' ? prefix + '.' : '') + a,
            ),
          )
        } else {
          if (match(obj, a)) {
            res.push(obj)
          }
        }
      }
    }
    // @ts-expect-error ensure o is a BlockContent
    o = decycle(o)

    Object.keys(o).forEach(search(o, v))
  }

  innerSearch(json, value)

  return res
}
